import { createContext, useContext } from 'react'

/**
 * Whether the surrounding table is rendering in the dense mobile layout.
 *
 * Provided by `Common/Table` alongside the `data-dense-table` attribute that drives the
 * CSS (see `assets/styles/denseTable.scss`). The CSS handles everything that is purely
 * presentational; this context is for the decisions that cannot be made in a
 * stylesheet — abbreviating a column header, and formatting a number as `$1.2M` rather
 * than `1,234,567.00`. Neither is something CSS can do to text it did not author.
 *
 * A leaf module on purpose: `TableFiltersRow`, `TableCell` and `FormattedTableCell` all
 * need it, and importing it from `Table.tsx` would make each of them a cycle back
 * through the component that renders them.
 *
 * Defaults to `false`, so a table cell rendered outside a `Common/Table` — the client
 * portal's `ExternalTable` builds its own MUI table — keeps its desktop formatting until
 * that surface opts in explicitly.
 */
const DenseTableContext = createContext(false)

export const DenseTableProvider = DenseTableContext.Provider

export const useIsDenseTable = (): boolean => useContext(DenseTableContext)

export default DenseTableContext
